import { useState } from "react";
import { Link } from "react-router-dom";

import { HEADER_CONFIG } from "@/shared/config/header.config";
import { WHITE_LABEL_CONFIG } from "@/whiteLable";

type Props = {
  className?: string;
  imageClassName?: string;
  textClassName?: string;
};

export default function BrandLogo({
  className = "flex flex-col leading-tight",
  imageClassName = "h-12 w-auto object-contain",
  textClassName = "text-2xl font-extrabold tracking-tight text-theme-text",
}: Props) {
  const [hasImageError, setHasImageError] = useState(false);
  const { brand } = HEADER_CONFIG;
  const { logo, fallbackText } = WHITE_LABEL_CONFIG.brand;
  const showImageLogo = Boolean(logo?.src) && !hasImageError;
  const safeFallbackText = fallbackText?.trim() || logo?.alt?.trim() || "Brand";

  return (
    <Link to={brand.link || "/"} className={className}>
      {showImageLogo ? (
        <img
          src={logo.src}
          alt={logo.alt}
          width={logo.width}
          height={logo.height}
          className={imageClassName}
          onError={() => setHasImageError(true)}
        />
      ) : (
        <span className={textClassName}>{safeFallbackText}</span>
      )}
    </Link>
  );
}
